export const DisplayDateFormat = 'DD.MM.YYYY.';
export const DisplayTimeFormat = 'HH:mm:ss';
export const DisplayTimeShortFormat = 'HH:mm';
export const DisplayFullFormat = 'DD.MM.YYYY. HH:mm';
export const DateFormat = 'YYYY-MM-DD';
export const JavaFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';
